import styled from 'react-emotion'

import Colors from '../../../themes/Colors'
import { mobile, customDevice, tablet } from '../../../utils/mixins'
import {
  Typo12WhiteDB,
  Typo14IceBlueTwoDINDI
} from '../../../themes/Fonts/Din2014'

import { CloudinaryS3Image } from '../../CloudinaryS3Image'

export const PriceCardsSection = styled('div')`
  ${mobile} {
    padding-top: 40px;
    padding-bottom: 0px;
  }
  ${tablet} {
    padding-top: 0;
    padding-bottom: 0;
  }
  @media (min-width: 1200px) {
    padding-bottom: 20px;
  }
`

export const ResponsiveContainer = styled('div')`
  width: 1160px;
  margin: auto;
  display: flex;
  flex-direction: column;
  ${mobile} {
    width: 100%;
  }
  ${customDevice(1000, 1161)} {
    width: 900px;
  }
  ${customDevice(1161, 1279)} {
    width: 1000px;
  }
`

export const PriceCardsContainer = styled(ResponsiveContainer)`
  ${mobile} {
    padding-bottom: 10px;
  }
`

export const PrevArrowSection = styled('div')`
  position: absolute;
  left: -2.2%;
  top: 46%;
  z-index: 10;
  cursor: pointer;
  ${mobile} {
    display: none;
  }
  ${tablet} {
    left: -2.2%;
  }
`
export const SliderContainer = styled('div')`
  padding-top: 20px;
  position: relative;
  ${customDevice(320, 767)} {
    padding-top: 0;
  }
`

export const PriceCardSvgContainer = styled('div')`
  pointer-events: none;
  user-select: none;
  display: flex;
  padding-bottom: 10px;
  padding-top: 10px;
  padding-left: 18px;
  padding-right: 18px;
  border-radius: 50%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: ${Colors.white};
  visibility: ${props => (props.disableArrow ? 'hidden' : 'initial')};
`
export const PriceCardNextSvgContainer = styled('div')`
  pointer-events: none;
  user-select: none;
  display: flex;
  padding-bottom: 10px;
  padding-top: 14px;
  padding-left: 18px;
  padding-right: 18px;
  transform: rotate(180deg);
  border-radius: 50%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: ${Colors.white};
  visibility: ${props => (props.disableArrow ? 'hidden' : 'initial')};
`

export const NextArrowSection = styled('div')`
  cursor: pointer;
  position: absolute;
  right: -2%;
  top: 46%;
  z-index: 10;
  ${mobile} {
    display: none;
  }
`
export const CardItemContainer = styled('div')`
  margin-right: ${props => (props.removeRightMargin ? `0` : `24px !important`)};
  position: relative;
  cursor: ${props => (props.isMembershipCard ? 'pointer' : null)};
  width: 320px;
  :nth-last-child(1) {
    width: auto !important;
    margin-right: 0 !important;
    ${customDevice(320, 601)} {
      margin-right: unset !important;
    }
  }
  ${customDevice(320, 601)} {
    margin-left: unset !important;
    margin-right: unset !important;
  }
  ${tablet} {
    margin-right: 0 !important;
  }
  ${customDevice(1024, 1199)} {
    margin-right: 24px !important;
  }
`
export const TestimonialDescriptionContainer = styled('div')`
  display: flex;
  flex-direction: column;
`

export const KnowMoreButton = styled(Typo12WhiteDB)`
  border: none;
  padding-left: 20px;
  padding-right: 20px;
  position: absolute;
  bottom: 16px;
  right: 60px;
  padding-top: 8px;
  padding-bottom: 8px;
  background-color: ${Colors.pumpkinOrange};
  cursor: pointer;
  :hover {
    color: ${Colors.white};
    outline: none;
    text-decoration: none;
  }
  :focus {
    color: ${Colors.white};
    outline: none;
    text-decoration: none;
  }
  ${mobile} {
    bottom: 10px;
    right: 45px;
  }
  ${tablet} {
    bottom: 16px;
    right: 110px;
  }
`

export const CardImage = styled(CloudinaryS3Image)`
  margin-right: 20px;
  margin-top: 18px;
  height: 224px;
  :nth-last-child(1) {
    margin-right: 0;
  }
  ${mobile} {
    height: 160px;
  }
`

export const ImageModalWrapperContainer = styled('div')``

export const CardImageContainer = styled('a')`
  cursor: ${props => (props.isMembershipCard ? 'pointer' : null)};
`

export const CardContainer = styled('div')`
  display: flex;
  position: relative;
`
export const DesktopSlider = styled('div')`
  ${mobile} {
    display: none;
  }
`

export const DesktopCardsWrapper = styled('div')`
  display: flex;
  justify-content: center;
  ${mobile} {
    display: none;
  }
  ${customDevice(1024, 1100)} {
    width: 920px;
    overflow: scroll;
    margin: auto;
    justify-content: ${props => (props.alignCenter ? 'center' : 'flex-start')};
  }
  ${customDevice(1101, 1199)} {
    width: 980px;
    overflow: scroll;
    margin: auto;
    justify-content: ${props => (props.alignCenter ? 'center' : 'flex-start')};
  }
`

export const MobileSlider = styled('div')`
  display: none;
  ${mobile} {
    display: block;
    margin-left: 5%;
  }
  ${tablet} {
    display: block;
    margin-left: 5%;
  }
`
export const MobileContainer = styled('div')`
  display: flex;
  flex-direction: row;
  overflow: scroll;
  justify-content: ${props =>
    props.isOnlyOnePriceCardPresent ? 'center' : 'flex-start'};
  ::-webkit-scrollbar {
    width: 0 !important;
  }
`
export const FormWrapper = styled('div')`
  display: block;
  ${customDevice(992, 1023)} {
    display: none;
  }
`

export const CloseButton = styled.button``

export const CloseImage = styled(CloudinaryS3Image)``

export const ImageContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;

  ${mobile} {
    padding-top: 10px;
  }
`

export const MembershipCardImage = styled(CloudinaryS3Image)`
  object-fit: contain;
  margin-bottom: 20px;
  width: 400px;

  ${mobile} {
    margin-bottom: 16px;
    width: auto;
  }
`

export const PointContentWrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  ${mobile} {
    margin-bottom: 9px;
  }
`

export const Point = styled('div')`
  width: 4px;
  height: 4px;
  background-color: ${Colors.whiteSeven};
  border-radius: 50%;
`

export const VisitText = styled(Typo14IceBlueTwoDINDI)`
  margin-left: 3px;
  line-height: normal;
  letter-spacing: 0.5px;

  ${mobile} {
    font-size: 11px;
    margin-left: 2px;
    line-height: normal;
    letter-spacing: normal;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/PriceCards/styledComponents.js